import Vue from 'vue'
import App from './App.vue'
import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'

import router from '@/router'

Vue.config.productionTip = false
Vue.use(ToastPlugin, {
  position: 'top'
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
